import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const User = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M12 2.708c5.523 0 10 4.478 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10m0 14.75c-1.936 0-3.686.956-4.919 2.18A8.46 8.46 0 0 0 12 21.207a8.46 8.46 0 0 0 4.918-1.57c-1.233-1.223-2.983-2.18-4.918-2.18m0-13.25a8.5 8.5 0 0 0-6.062 14.456c1.45-1.476 3.59-2.705 6.062-2.706 2.471 0 4.611 1.23 6.061 2.706a8.47 8.47 0 0 0 2.439-5.956 8.5 8.5 0 0 0-8.5-8.5m0 3.75a3.75 3.75 0 1 1 0 7.5 3.75 3.75 0 0 1 0-7.5m0 1.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5'
        fill='currentColor'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 22.708c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10m3-12a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-3 10a7.98 7.98 0 0 1-5.714-2.4c1.332-1.595 3.319-2.6 5.714-2.6s4.383 1.005 5.714 2.6a7.98 7.98 0 0 1-5.714 2.4'
        fill='currentColor'
      />
    )}
  </IconBase>
);
